(function () {
    'use strict';

    function fileUploadsService($rootScope) {
        var fileUploaders = [];
        var fileUploads = [];

        function markFileAsComplete(fileUpload) {
            var fileUploadIndex = _.findIndex(fileUploads, { Guid: fileUpload.Guid });
            fileUploads[fileUploadIndex].Status = 'completed';

            $rootScope.$apply();
        }

        function addUploader(uploader) {
            fileUploaders.push(uploader);
        }

        function markFileAsUploading(guid) {
            fileUploads[_.findIndex(fileUploads, { Guid: guid })].Status = 'uploading';
        }

        function removeFile(index, selectedFile) {
            fileUploaders[index].cancel(selectedFile.UploaderId);
            fileUploads.splice(_.findIndex(fileUploads,
            { Guid: selectedFile.Guid }, 1));
        }

        return {
            markFileAsComplete: markFileAsComplete,
            fileUploads: fileUploads,
            addUploader: addUploader,
            markFileAsUploading: markFileAsUploading,
            uploaders: fileUploaders,
            removeFile: removeFile
        };
    }

    fileUploadsService.$inject = ['$rootScope'];

    angular.module('ecap.workflow').service('fileUploadsService', fileUploadsService);
})();
